/*
Aditya 09/29/2022 2700753823 Implemented save alert for Global Fields module
Sohel  10/14/2022 2700753823 Global Field Added Code Comments Changes
Asharf 10/17/2022 2700753823 Added Global Field Ant tabs
Ashraf 11/27/2022 2698947782 Added data repository tab
Sai maheshwar 11/28/2022  3031450488 rearranged global fields tabs
Ashraf 11/28/2022  3031450488 rearranged global fields tabs
Rajesh 12/02/022 3031450488 removed field list
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import SaveAlert from '../../../../components/DialogBox/SaveAlert';
import DataRepositories from '../DataRepositories';
import DataRepositoryTab from '../DataRepositoryTab';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function GlobalTabs({value, setValue, openTabLevel, setOpenTabLevel}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {openTabLevel && (
        <SaveAlert
          setTabValue={setValue}
          setOpen={setOpenTabLevel}
          open={openTabLevel}
          tabvalue={value}
        />
      )}
      <div className={classes.subContent}>
        {value === 0 && <DataRepositoryTab StepperFieldList={false} />}
        {value === 1 && <DataRepositories StepperFieldList={false}/>}
        {/* {value === 2 && <GlobalFieldGroup />} */}
        {/* {value === 2 && <GlobalFieldList StepperFieldList={false} />} */}
      </div>
    </div>
  );
}
